import type { ReferralFormValues } from '../../../../types';

export const REFERRAL_INITIAL_VALUES: ReferralFormValues = {
  referral_physician_name: '',
  diagnosis_date: null,
  diagnosis_city: '',
  diagnosis_state: '',
  diagnostic_assessments_used: [],
  diagnoses: [],
};

export const REFERRAL_FORM_FIELD_NAMES = [
  'referral_physician_name',
  'diagnosis_date',
  'diagnosis_city',
  'diagnosis_state',
  'diagnostic_assessments_used',
  'diagnoses',
] as const;

export const REFERRAL_DATE_FIELD_NAMES = ['diagnosis_date'] as const;
export const REFERRAL_LIST_FIELD_NAMES = ['diagnostic_assessments_used', 'diagnoses'] as const;
